import {
  MimaButton,
  MimaText,
  Modal,
} from '../../components';

const DeleteFaq = ({ closeModal, items, handleDelete, loading, goBack }) => {

  return (
    <Modal closeModal={closeModal} goBack={goBack}>
      <MimaText variant="subtitleBold" align="center" mb={3}>
        Delete FAQ
      </MimaText>

      <MimaText mb={2} align="center">
        Are you sure you want to delete <br></br><span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{items.question}</span>
      </MimaText>

      <div className='modal__beside'>
        <MimaButton
          title={'Yes'}
          width={18}
          onClick={() => handleDelete(items._id)}
          loading={loading}
        />

        <MimaButton
          title={'Cancel'}
          width={18}
          buttonColor={'grey'}
          onClick={() => closeModal()}
        />
      </div>
    </Modal>
  );
};

export default DeleteFaq;